import * as actionTypes from '../../actionTypes';
import {merge} from 'lodash';

// initial state
export const initialState = {};

export default function technologySurveyReducer(state = initialState, {type, technologySurvey}) {
  switch (type) {
    case actionTypes.CLEAR_APPLICANT :
    case actionTypes.LOG_OUT :
      return {};
    case actionTypes.UPDATE_APPLICANT :
    case actionTypes.UPDATE_TECHNOLOGY_SURVEY :
      if(technologySurvey && technologySurvey !== state) {
        return merge({}, state, technologySurvey);
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./shared/redux/reducers/technologySurvey/index.js